import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const AdminUserSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  email: Yup.string().min(1).required('Email is required'),
  firstName: Yup.string().min(1).required('First name is required'),
  lastName: Yup.string().min(1).required('Last name is required'),
  role: Yup.string().min(1).required('Role is required'),
});

export type AdminUserDataType = Yup.InferType<typeof AdminUserSchema>;

type InitialValues = {
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;

  role: string;
};

export const AdminUserInitialValues: InitialValues = {
  phoneNumber: '',
  email: '',
  firstName: '',
  lastName: '',

  role: '',
};

export interface IUserResponse {}

export enum AdminUserRole {
  WAREHOUSE_ADMIN = 'WAREHOUSE_ADMIN',
  WAREHOUSE_USER = 'WAREHOUSE_USER',
  WAREHOUSE_MANAGER = 'WAREHOUSE_MANAGER',
}
export interface IAdminUserRequest {
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface IAdminUserResponse {}
